export const lazyLoader = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const lazyImages = [...document.querySelectorAll("img.lazy")];

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(async function(entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.dataset.src ? lazyImage.src = lazyImage.dataset.src : lazyImage.removeAttribute('data-src');
            lazyImage.dataset.srcset ? lazyImage.srcset = lazyImage.dataset.srcset : lazyImage.removeAttribute('data-srcset');

            await new Promise((resolve, reject) => lazyImage.onload = () => resolve(true));

            if (lazyImage.matches('.lazy--thumb')) {
              lazyImage.classList.add('blur-none', 'scale-100');
            }

            lazyImage.removeAttribute('data-src');
            lazyImage.removeAttribute('data-srcset');
            lazyImage.classList.remove('lazy');
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      }, {
        rootMargin: '300px 0px', // Загружать за 300px до попадания в вьюпорт
        threshold: 0
      });
  
      lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }
  });
}

export const lazyLoaderBg = () => {
  document.addEventListener('DOMContentLoaded', () => {
    var lazyBgs = [].slice.call(document.querySelectorAll(".lazy-bg"));
  
    if ("IntersectionObserver" in window) {
      let lazyBgObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let lazyBg = entry.target;
            lazyBg.style.backgroundImage = `url('${lazyBg.getAttribute('data-bg')}')`;

            lazyBg.classList.remove("lazy-bg");
            lazyBg.setAttribute('data-bg', '');
            lazyBgObserver.unobserve(lazyBg);
          }
        });
      });
  
      lazyBgs.forEach(function(lazyBg) {
        lazyBgObserver.observe(lazyBg);
      });
    } else {
      // Possibly fall back to event handlers here
    }
  });
}

export const lazyLoaderSvg = () => {
  document.addEventListener('DOMContentLoaded', () => {
    var lazySvgs = [].slice.call(document.querySelectorAll(".lazy-svg"));
  
    if ("IntersectionObserver" in window) {
      let lazySvgObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let lazySvg = entry.target;
            let lazySvgSrc = lazySvg.getAttribute('data-svg');
            lazySvg.querySelector('use').setAttribute('href', lazySvgSrc);

            lazySvg.classList.remove("lazy-svg");
            lazySvg.removeAttribute('data-svg');
            lazySvgObserver.unobserve(lazySvg);
          }
        });
      });
  
      lazySvgs.forEach(function(lazySvg) {
        lazySvgObserver.observe(lazySvg);
      });
    } else {
      // Possibly fall back to event handlers here
    }
  });
}

export const lazyLoaderLottie = () => {
  document.addEventListener('DOMContentLoaded', () => {
    var lazyLotties = [].slice.call(document.querySelectorAll(".lazy-lottie"));
  
    if ("IntersectionObserver" in window) {
      let lazyLottieObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(async (entry) => {
          if (entry.isIntersecting) {
            await import("@lottiefiles/lottie-player");
            const lazyLottie = entry.target;
            const lottiePlayer = document.createElement('lottie-player');

            Array.from(lazyLottie.attributes).forEach(attr => {
                lottiePlayer.setAttribute(attr.name, attr.value);
            });

            lazyLottie.replaceWith(lottiePlayer);

            lottiePlayer.addEventListener('ready', e => {
              lottiePlayer.play();
            })

            lottiePlayer.classList.remove("lazy-lottie");
            lazyLottieObserver.unobserve(lazyLottie);
          }
        });
      });
  
      lazyLotties.forEach(function(lazyLottie) {
        lazyLottieObserver.observe(lazyLottie);
      });
    } else {
      // Possibly fall back to event handlers here
    }
  });
}